module.exports = __webpack_public_path__ + "static/media/turntable.05c67b91.svg";